import { NgModule } from 'ng-metadata/core';
import { StepComponent } from './step.component';
import './stepper.component.scss';

/**
 * @ngdoc module
 * @name mw.components.stepper
 * @description
 *
 * Stepper
 */
@NgModule({
    declarations: [ StepComponent ]
})
export class StepperModule {}



// WEBPACK FOOTER //
// ./src/lib/components/stepper/stepper.module.ts